import { render, staticRenderFns } from "./permission-assign.vue?vue&type=template&id=51437462&"
import script from "./permission-assign.vue?vue&type=script&lang=js&"
export * from "./permission-assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports